<!-- eslint-disable max-len -->
<template>
    <div :id="'dialogModal' + name" class="modal fade" tabindex="-1" aria-modal="true" role="dialog">
        <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
            <div class="modal-content">
                <!-- Header -->
                <div class="modal-top-cover bg-dark text-center" style="min-height: 4.5rem">
                    <figure class="position-absolute end-0 start-0" style="bottom: -5px">
                        <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 1920 100.1">
                            <path fill="#fff" d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"></path>
                        </svg>
                    </figure>

                    <div class="modal-close" style="top: 1rem">
                        <button type="button" class="btn-close btn-sm btn-close-light" @click="hideModal"></button>
                    </div>
                </div>
                <!-- End Header -->

                <div class="modal-top-cover-icon">
                    <span class="icon icon-lg icon-light icon-circle icon-centered shadow-sm">
                        <img src="@/assets/svg/icon.svg" height="30" />
                    </span>
                </div>
                <div class="modal-body">
                    <p style="hyphens: auto" v-html="options.description || $t('dialog.default.description')"></p>
                </div>
                <div class="modal-footer" style="padding: 0.8rem">
                    <button type="button" class="btn btn-primary" @click="accept">{{ actionYesTitle || $t('actions.yes') }}</button>
                    <button type="button" class="btn btn-white" v-if="!hideCancel" @click="hideModal">{{ actionNoTitle || $t('actions.no') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Modal } from 'bootstrap'

export default {
    name: 'DialogModal',
    props: {
        options: {
            type: Object,
            default: () => {
                return {}
            },
        },
        hideCancel: {
            type: Boolean,
            default: false,
        },
        name: {
            type: String,
            default: '',
        },
        actionYesTitle: {
            type: String,
            default: null,
        },
        actionNoTitle: {
            type: String,
            default: null,
        },
        showModal: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        showModal(newValue, oldValue) {
            if (newValue === true) {
                this.modalActive()
            }
        },
    },
    methods: {
        modalActive: function () {
            this.modalInstance = new Modal(document.getElementById('dialogModal' + this.name), {
                target: '#my-modal',
                backdrop: 'static',
                keyboard: false,
            })
            this.modalInstance.show()
        },
        hideModal: function () {
            this.modalInstance.hide()
            this.$emit('closeModal')
        },
        accept: function () {
            this.modalInstance.hide()
            this.$emit('handleAccept')
        },
    },
}
</script>

<style scoped></style>
